import { useOutletContext } from '@remix-run/react'
import { RootOutletContext } from '~/root'

const utmFieldAssignments = {
  '38': 'utm_medium',
  '37': 'utm_source',
  '39': 'utm_campaign',
  '40': 'utm_content',
  '41': 'utm_keyword',
  '42': 'campaign_code',
  '57': 'visitor_id',
}

export const UtmFields = () => {
  const { tracking } = useOutletContext<RootOutletContext>()
  const fields = utmFieldAssignments
  const trackingMap = new Map(Object.entries(tracking))

  const fieldInputs = Object.entries(fields).map(([activeCampaignId, value]) =>
    trackingMap.has(value) ? (
      <input
        key={activeCampaignId}
        type="hidden"
        name={`field[${activeCampaignId}]`}
        value={trackingMap.get(value)}
      />
    ) : null,
  )

  return <>{fieldInputs}</>
}
